import React, { useState, useCallback } from "react";
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  CircularProgress,
  Button,
  IconButton,
  TextField,
  MenuItem,
  ListItemText,
  Paper,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import { LoadingButton } from "@mui/lab";
import { API, graphqlOperation } from "aws-amplify";
import { createAccountMaster, createUserPreference } from "../../../graphql";
import { listBankDetails } from "../../../graphql";
import { IfscFetch } from "../../../library/IfscFetch";
import {
  showSuccessSnackbar,
  showWarningSnackbar,
} from "../../../components/snackBar/snakbar";
import {
  useCreateAccountMasterMutation,
  useCreateBankDetailsMutation,
  useListAccountMasterv2Query,
} from "../../../redux/apis/accountMaster.api";
import { useSelector } from "react-redux";
import { useListGroupMasterQuery } from "../../../redux/apis/accountGroupMaster.api";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  boxShadow: 24,
  // p: 4,
  outline: "none",
  minWidth: "500px",
};
const AccountTypes = [
  { option: "Current Account", value: "1" },
  { option: "Savings Account", value: "2" },
  { option: "Overdraft", value: "3" },
];

const AddBankAccountModal = ({
  open,
  setOpen,
  setData,
  accountType,
  data,
  Type,
  updatetedTableRow,
  rowIndex,
  closeAccountModal,
  setNewgroup,
}) => {
  const { data: groupsList, isLoading, isError } = useListGroupMasterQuery();
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [listOfBanks, setListOfBanks] = useState([]);
  const [ledger, setLedger] = useState([]);
  const [group, setGroup] = useState([]);
  let getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );
  
    const companyDetails = useSelector(
      (state) => state?.companyReducer?.companyDetails
    );
    let companyType =
    getCompany?.relatedcompanydetailsnew?.[0].registrationtype;
  
    let compositePercent =
    getCompany?.relatedcompanydetailsnew?.[0]?.comppercentage;
  const [
    createBankDetails,
    {
      isLoading: isCreatingAccount,
      isError: isCreateAccountError,
      isSuccess: isCreateAccountSuccess,
      error: createAccountError,
    },
  ] = useCreateBankDetailsMutation();
  const [
    createAccountMaster,
    {
      isLoading: isCreatingLedger,
      isError: isCreateLedgerError,
      isSuccess: isCreateLedgerSuccess,
      error: createLedgerError,
    },
  ] = useCreateAccountMasterMutation();
  const [state, setState] = useState({
    name: "",
    bankName: "",
    bankAccountNo: "",
    ifscCode: "",
    cash: 0,
    swiftCode: "",
    accountType: "",
    branch: "",
    groupName: { label: "Bank Accounts", value: 17 },
    errorStatus: {
      name: false,
      bankName: false,
      bankAccountNo: false,
      ifscCode: false,
      cash: false,
      swiftCode: false,
      accountType: false,
      branch: false,
      groupName: false,
    },
    errorFields: {
      name: "",
      bankName: "",
      bankAccountNo: "",
      ifscCode: "",
      cash: 0,
      swiftCode: "",
      branch: "",
      accountType: "",
      groupName: "",
    },
  });
  const handleChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === "name") {
      value = value
        ?.toLowerCase()
        .replace(/\b\w/g, (match) => match.toUpperCase());
    }
    if (value == "" && state?.ifscCode !== "") {
      setState((prev) => ({
        ...prev,
        [name]: value,
        erroStatus: {
          ...prev.errorStatus,
          [name]: true,
        },
        errorFields: {
          ...prev.errorFields,
          [name]: name + " is Required",
        },
      }));
    } else {
      setState((prev) => ({
        ...prev,
        [name]: value,
        erroStatus: {
          ...prev.errorStatus,
          [name]: false,
        },
        errorFields: {
          ...prev.errorFields,
          [name]: "",
        },
      }));
    }
  };

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setState((prev) => ({
        ...prev,
        name: "",
        bankName: "",
        bankAccountNo: "",
        ifscCode: "",
        cash: 0,
        swiftCode: "",
        accountType: "",
        branch: "",
        groupName: { label: "", value: "" },
        errorStatus: {
          name: false,
          bankName: false,
          bankAccountNo: false,
          ifscCode: false,
          cash: false,
          swiftCode: false,
          accountType: false,
          branch: false,
          groupName: false,
        },
        errorFields: {
          name: "",
          bankName: "",
          bankAccountNo: "",
          ifscCode: "",
          cash: 0,
          swiftCode: "",
          accountType: "",
          branch: "",
          groupName: "",
        },
      }));
      if (closeAccountModal) {
        closeAccountModal();
      }
      setLoading(false);
      setOpen(false);
    }
  };

  function formValidation(data) {
    let isvalid = true;
    let obj = { ...state };
    const numberRegex = /^\d+(\.\d{1,2})?$/;
    Object.keys(data)?.map((key) => {

      console.log(key,"***====>key")
      
      if (key === "name") {
        if (data[key].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.name = "Name is required";
          obj.errorStatus.name = true;
        } else {
          obj.errorFields.name = "";
          obj.errorStatus.name = false;
        }
      }
      if(key === "groupName"){
        if (data[key].label == "") {
          isvalid = false;
          obj.errorFields.groupName = "Group is required";
          obj.errorStatus.groupName = true;
        } else {
          obj.errorFields.groupName = "";
          obj.errorStatus.groupName = false;
        }
      }
      if (obj?.ifscCode !== "") {
        if (key === "bankName") {
          if (data[key] == "") {
            isvalid = false;
            obj.errorFields.bankName = "Bank Name is required";
            obj.errorStatus.bankName = true;
          } else {
            obj.errorFields.bankName = "";
            obj.errorStatus.bankName = false;
          }
        }
        if (key === "bankAccountNo") {
          if (data[key] == "") {
            isvalid = false;
            obj.errorFields.bankAccountNo = "Bank Account Number is required";
            obj.errorStatus.bankAccountNo = true;
          } else {
            if (!new RegExp(/^^\d{9,34}$/).test(data[key])) {
              isvalid = false;
              obj.errorFields.bankAccountNo = "Invalid Bank Account No";
              obj.errorStatus.bankAccountNo = true;
            } else {
              obj.errorFields.bankAccountNo = "";
              obj.errorStatus.bankAccountNo = false;
            }
          }
        }
        if (key === "accountType") {
          if (data[key] == "") {
            console.log("****inside group empty")
            isvalid = false;
            obj.errorFields.accountType = "Bank Account Type is required";
            obj.errorStatus.accountType = true;
          } else {
            obj.errorFields.accountType = "";
            obj.errorStatus.accountType = false;
          }
        }
        if (key === "branch") {
          if (data[key] == "") {
            isvalid = false;
            obj.errorFields.branch = "Branch is required";
            obj.errorStatus.branch = true;
          } else {
            obj.errorFields.branch = "";
            obj.errorStatus.branch = false;
          }
        }


      }
    });
    setState(obj);
    return isvalid;
  }
  async function listSelectedBanKDetails() {
    try {
      const res = await API.graphql(graphqlOperation(listBankDetails));
      if (res.data.listBankDetails.length > 0) {
        res.data.listBankDetails.map((ele) => {
          if (ele.objecttype === "COMPANY") {
            setListOfBanks(ele);
          }
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  const handleAutoGenerateLedgerNameByIfscCode = (e) => {
    // if (
    //   // state?.edit?.name === false &&
    //   state?.bankName?.length &&
    //   state.branch?.length &&
    //   state.bankAccountNo?.length
    // ) {
    const value =
      state.bankName +
      "" +
      state.branch.slice(0, 4) +
      "" +
      state.bankAccountNo.toString().slice(-4);
    setState((prev) => ({
      ...prev,
      name: value,
    }));
    // }
  };
  const handleAutoGenerateLedgerNameByBankName = (e) => {
    const value =
      e?.target?.value +
      "" +
      state.branch.slice(0, 4) +
      "" +
      state.bankAccountNo.toString().slice(-4);
    setState((prev) => ({
      ...prev,
      name: value,
    }));
    // }
  };
  const handleAutoGenerateLedgerNameByBranch = (e) => {
    const value =
      state?.bankName +
      "" +
      e?.target?.value.slice(0, 4) +
      "" +
      state.bankAccountNo.toString().slice(-4);
    setState((prev) => ({
      ...prev,
      name: value,
    }));
    // }
  };
  const handleAutoGenerateLedgerNameByAccountNo = (e) => {
    if (
      // state?.edit?.name === false &&
      state?.bankName?.length &&
      state.branch?.length &&
      e?.target?.value?.length
    ) {
      const value =
        state.bankName +
        "" +
        state.branch.slice(0, 4) +
        "" +
        e?.target?.value?.toString().slice(-4);
      setState((prev) => ({
        ...prev,
        name: value,
      }));
    }
  };
  async function listGroup() {
    if (groupsList.length > 0) {
      let allAccounts = [];

      groupsList.map((ele) => {
        let groupName = ele.accountgroupname
          ?.replace(/([a-z])([A-Z])/g, "$1 $2")
          ?.trim();

        if (ele.accountgroupid === 17 || ele.accountgroupid === 29) {
          allAccounts.push({
            label: ele.accountgroupname,
            value: ele.accountgroupid,
            accountTypeCD: ele.accounttypecd,
            groupName,
          });
        }
      });

      setGroup(allAccounts);
    }
  }

  useEffect(() => {
    listGroup();
  }, [groupsList]);
  const { data: ledgerList } = useListAccountMasterv2Query();
  async function listLedgerData() {
    try {
      let allAccount = [];
      // const res = await API.graphql(graphqlOperation(listAccountMasterCustom));

      let res = { data: { listAccountMasterv2: ledgerList } };
      if (res?.data?.listAccountMasterv2 !== null) {
        setLedger(res.data.listAccountMasterv2);
        if (accountType === "ledgerAccount") {
          res.data.listAccountMasterv2.map((ele) => {
            if (ele.is_active === 1) {
              allAccount.push({
                label: ele.accountname,
                value: ele.accountsid,
              });
            }
          });
          
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    if (open) {
      listLedgerData();
      listSelectedBanKDetails();
    }
    if(accountType==="ledgerAccount"){
    setState((prev) => ({
      ...prev,
      name: data.name,
      groupName: { label: data?.group?.label, value: data?.group?.value },
    }));
  }
  }, [open, ledgerList]);


  useEffect(() => {
      const controlAndS = (e) => {
        if (e.ctrlKey && e.key.toLowerCase() === "s" && open) {
          e.preventDefault();
          saveChanges()
        }
      };
  
      window.addEventListener("keydown", controlAndS);
  
      return () => {
        window.removeEventListener("keydown", controlAndS);
      };
    }, [state,open]);
    
  async function addBankDetails(bankDetails) {

    try {
     
      const res = await createBankDetails({
        createBankDetailsInput: bankDetails,
      });


      if (res.data?.[0]?.bankdetailsid !== "") {
        if (listOfBanks.length === 0) {
          const userPreferenceData = {
            additionalvalue: "",
            attributetypecd: "SelectedBankDetails",
            attributevalue: res.data[0]?.bankdetailsid,
          };
        
          const resUserPreferenceData = await API.graphql(
            graphqlOperation(createUserPreference, {
              createUserPreferenceInput: userPreferenceData,
            })
          );
        }
        if (accountType === "receivedAccount") {
          setData((prev) => ({
            ...prev,
            bankReceivedAccount: {
              label: res.data?.[0].ledgeraccount,
              value: res.data?.[0].bankdetailsid,
            },
          }));
        }

        if (accountType === "ledgerAccount") {
          if (
            (Type &&
              (Type === "Purchase" ||
                Type === "Sales" ||
                Type === "CreditNote" ||
                Type === "DebitNote")) ||
            Type === "Journal"
          ) {
            updatetedTableRow[rowIndex] = {
              ...updatetedTableRow[rowIndex],
              ledgerAccount: {
                label: res.data?.[0].ledgeraccount,
                value: res.data?.[0].bankdetailsid,
              },
              GSTRate: companyType == 3 ? compositePercent : "",
            };
            setData(updatetedTableRow);
          } else {
            setData((prev) => ({
              ...prev,
              ledgerAccount: {
                label: res.data?.[0].ledgeraccount,
                value: res.data?.[0].bankdetailsid,
              },
            }));
          }
        }
        if (accountType === "Payment") {
          setData((prev) => ({
            ...prev,
            paidFrom: {
              label: res.data?.[0].ledgeraccount,
              value: res.data?.[0].bankdetailsid,
            },
            erroStatus: { ...prev.errorStatus, paidFrom: false },
            errorFields: { ...prev.errorFields, paidFrom: "" },
          }));
        }
        if (accountType === "Receipt") {
          setData((prev) => ({
            ...prev,
            receivedTo: {
              label: res.data?.[0].ledgeraccount,
              value: res.data?.[0].bankdetailsid,
            },
            erroStatus: { ...prev.errorStatus, receivedTo: false },
            errorFields: { ...prev.errorFields, receivedTo: "" },
          }));
        }
        setLoading(false);
        setState((prev) => ({
          ...prev,
          name: "",
          bankName: "",
          bankAccountNo: "",
          ifscCode: "",
          cash: 0,
          swiftCode: "",
          branch: "",
          accountType: "",
          groupName: { label: "", value: "" },
          errorStatus: {
            ...prev.errorStatus,
            name: false,
            bankName: false,
            bankAccountNo: false,
            ifscCode: false,
            cash: false,
            swiftCode: false,
            branch: false,
            accountType: false,
            groupName: false,
          },
          errorFields: {
            ...prev.errorFields,
            name: "",
            bankName: "",
            bankAccountNo: "",
            ifscCode: "",
            cash: 0,
            swiftCode: "",
            branch: "",
            accountType: "",
            groupName: "",
          },
        }));
        showSuccessSnackbar("Account created Successfully");
        handleClose();
        setNewgroup(false)
      } else {
        setLoading(false);
        setOpen(true);
        showWarningSnackbar(res.data.statusmessage);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function saveChanges() {
    const {
      name,
      bankAccountNo,
      bankName,
      ifscCode,
      accountType,
      branch,
      groupName,
    } = state;
    const formData = {
      name,
      bankName,
      bankAccountNo,
      ifscCode,
      accountType,
      branch,
      groupName,
    };

    console.log(groupName,"****groupName")

    if (formValidation(formData)) {
      setBackdropOpen(true);
      setLoading(true);
      try {
        const LedgerData = {
          accountgroupid: groupName.value,
          accountname: state?.name,
          accounttypecd: "BS",
          hsnsaccode: 0,
        };

        const resledger = await createAccountMaster({
          createAccountMasterInput: LedgerData,
        });

        if (resledger?.data?.statuscode === "Success") {
          const bankDetails = {
            bankaccountnumber: state.bankAccountNo,
            bankname: state.bankName,
            branch: state.branch,
            ifsccode: state.ifscCode,
            notes: "",
            objectid: getCompany?.companyid,
            objecttype: "COMPANY",
            ledgeraccount: state.name,
            bankaccounttype: Number(state.accountType),
            swiftcode: state.swiftCode,
            cash: 0,
            upi: "",
            companybranchid: 0,
            expiredtimestamp: 0,
            bankdetailsid: resledger?.data?.accountsid,
          };

          await addBankDetails(bankDetails);
        } else {
          const errorMessage = resledger.error?.message;
          showWarningSnackbar(errorMessage);
        }
      } catch (error) {
        console.error("Error:", error);

        try {
          const rawMessage = error.errors[0].message.split("RDSHttp:")[1];
          const parsedMessage = JSON.parse(rawMessage).message;
          const errorMessage = parsedMessage.split("ERROR: ")[1].split(";")[0];
          showWarningSnackbar(errorMessage);
        } catch (parsingError) {
          console.error("Error parsing the error message:", parsingError);
        }

        setLoading(false);
        setBackdropOpen(false);
      } finally {
        // Ensure loading state and backdrop are closed, even if there is an error
        setLoading(false);
        setBackdropOpen(false);
      }
    }
  }

  return (
    <Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        onClose={handleClose}
      >
        <Fade in={open}>
          <Paper sx={style}>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={backdropOpen}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <Box
              sx={{
                backgroundColor: "primary.main",
                padding: "5px 15px",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: "#fff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  Add New Account
                  <IconButton aria-label="delete" onClick={handleClose}>
                    <CloseIcon sx={{ color: "#fff" }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>
            <Box sx={{ m: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: { sm: "flex-start" },
                  flexWrap: { xs: "wrap", md: "nowrap" },
                  flexDirection: { xs: "column", sm: "row" },
                  marginBottom: "0px",
                }}
              >
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <TextField
                    error={state.errorStatus.ifscCode == true ? true : false}
                    label="IFSC Code"
                    name="ifscCode"
                    id="ifscCode"
                    fullWidth
                    onBlur={(e) => {
                      handleAutoGenerateLedgerNameByIfscCode(e);
                    }}
                    value={state.ifscCode}
                    onChange={(e) => {
                      const value = e?.target?.value?.toUpperCase();
                      if (value.length > 11) {
                        return;
                      }
                      if (value != "") {
                        if (!new RegExp(/^[A-Z]{4}0[A-Z0-9]{6}$/).test(value)) {
                          setBackdropOpen(false);
                          setState((prev) => ({
                            ...prev,
                            ["ifscCode"]: value,
                            erroStatus: {
                              ...prev.errorStatus,
                              ["ifscCode"]: true,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              ["ifscCode"]: "IFSC Code is invalid",
                            },
                          }));

                          setState((prev) => ({
                            ...prev,
                            ["bankName"]: "",
                            erroStatus: {
                              ...prev.errorStatus,
                              ["bankName"]: false,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              ["bankName"]: "",
                            },
                          }));
                          setState((prev) => ({
                            ...prev,
                            ["branch"]: "",
                            erroStatus: {
                              ...prev.errorStatus,
                              ["branch"]: false,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              ["branch"]: "",
                            },
                          }));
                        } else {
                          setBackdropOpen(true);
                          setState((prev) => ({
                            ...prev,
                            ["ifscCode"]: value,
                            erroStatus: {
                              ...prev.errorStatus,
                              ["ifscCode"]: false,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              ["ifscCode"]: "",
                            },
                          }));
                          IfscFetch(value)
                            .then((e) => {
                              console.log(e.data);

                              setState((prev) => ({
                                ...prev,
                                ["bankName"]: e.data?.bankName,
                                erroStatus: {
                                  ...prev.errorStatus,
                                  ["bankName"]: false,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  ["bankName"]: "",
                                },
                              }));
                              setState((prev) => ({
                                ...prev,
                                ["branch"]: e.data.branchName,
                                erroStatus: {
                                  ...prev.errorStatus,
                                  ["branch"]: false,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  ["branch"]: "",
                                },
                              }));
                              let bno = state.bankAccountNo;
                              setState((prev) => ({
                                ...prev,
                                ["name"]:
                                  e.data?.bankName +
                                  e.data.branchName.slice(0, 4) +
                                  bno
                                    ?.toString()
                                    .slice(bno.length - 4, bno.length),
                                erroStatus: {
                                  ...prev.errorStatus,
                                  ["name"]: false,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  ["name"]: "",
                                },
                              }));
                              setBackdropOpen(false);
                            })
                            .catch((error) => {
                              setBackdropOpen(false);
                              showWarningSnackbar(
                                "IFSC not found in our database"
                              );
                              console.log(error);
                            });
                        }
                      } else {
                        setState((prev) => ({
                          ...prev,
                          ["ifscCode"]: "",
                          erroStatus: {
                            ...prev.errorStatus,
                            ["ifscCode"]: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            ["ifscCode"]: "",
                          },
                        }));
                        setState((prev) => ({
                          ...prev,
                          ["bankName"]: "",
                          erroStatus: {
                            ...prev.errorStatus,
                            ["bankName"]: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            ["bankName"]: "",
                          },
                        }));
                        setState((prev) => ({
                          ...prev,
                          ["branch"]: "",
                          erroStatus: {
                            ...prev.errorStatus,
                            ["branch"]: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            ["branch"]: "",
                          },
                        }));
                      }
                    }}
                    size="small"
                    sx={{
                      ".css-wgai2y-MuiFormLabel-asterisk": {
                        color: "danger.main",
                      },
                    }}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                  />
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.ifscCode}
                  </Typography>
                </Box>
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <TextField
                    error={state.errorStatus.bankName === true ? true : false}
                    name="bankName"
                    label="Bank Name"
                    variant="outlined"
                    size="small"
                    fullWidth
                    onBlur={(e) => {
                      handleAutoGenerateLedgerNameByBankName(e);
                    }}
                    required={state?.ifscCode !== "" ? true : false}
                    value={state.bankName}
                    onChange={(e) => {
                      const name = e.target.name;
                      const value = e.target.value;
                      if (value === "" && state?.ifscCode !== "") {
                        setState((prev) => ({
                          ...prev,
                          ["bankName"]: value,
                          erroStatus: {
                            ...prev.errorStatus,
                            ["bankName"]: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            ["bankName"]: "Bank Name is required",
                          },
                        }));
                      } else {
                        setState((prev) => ({
                          ...prev,
                          ["bankName"]: value,
                          erroStatus: {
                            ...prev.errorStatus,
                            ["bankName"]: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            ["bankName"]: "",
                          },
                        }));
                      }
                    }}
                    sx={{
                      ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                        fontSize: "14px",
                      },
                      label: {
                        fontSize: "14px",
                      },
                      ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                        fontSize: "14px",
                      },
                      ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                        color: "input.font",
                      },
                      ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                        borderColor: "input.border",
                      },
                      ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root": {
                        color: "input.font",
                      },
                      ".css-wgai2y-MuiFormLabel-asterisk": {
                        color: "danger.main",
                      },
                    }}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                  ></TextField>
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.bankName}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: { sm: "flex-start" },
                  flexWrap: { xs: "wrap", md: "nowrap" },
                  flexDirection: { xs: "column", sm: "row" },
                  marginBottom: "0px",
                }}
              >
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <TextField
                    error={state.errorStatus.branch == true ? true : false}
                    label="Branch"
                    name="branch"
                    required={state?.ifscCode !== "" ? true : false}
                    onBlur={(e) => {
                      handleAutoGenerateLedgerNameByBranch(e);
                    }}
                    id="branch"
                    fullWidth
                    value={state.branch}
                    onChange={(e) => handleChange(e)}
                    size="small"
                    sx={{
                      ".css-wgai2y-MuiFormLabel-asterisk": {
                        color: "danger.main",
                      },
                    }}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                  />
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.branch}
                  </Typography>
                </Box>
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <TextField
                    error={
                      state.errorStatus.bankAccountNo == true ? true : false
                    }
                    label="Bank Account Number"
                    name="bankAccountNo"
                    id="bankAccountNo"
                    fullWidth
                    inputProps={{ maxLength: 34 }}
                    onChange={(e) => {
                      if (state?.ifscCode !== "") {
                        if (e.target.value == "") {
                          setState((prev) => ({
                            ...prev,
                            bankAccountNo: e.target.value,
                            errorFields: {
                              bankAccountNo: "Bank Account No is required",
                            },
                            errorStatus: {
                              bankAccountNo: true,
                            },
                          }));
                        } else {
                          if (!new RegExp(/^^\d{9,34}$/).test(e.target.value)) {
                            setState((prev) => ({
                              ...prev,
                              bankAccountNo: e.target.value,
                              errorFields: {
                                ...prev.errorFields,
                                bankAccountNo: "Invalid Bank Account No",
                              },
                              errorStatus: {
                                ...prev.errorStatus,
                                bankAccountNo: true,
                              },
                            }));
                          } else {
                            setState((prev) => ({
                              ...prev,
                              bankAccountNo: e.target.value,
                              errorFields: {
                                ...prev.errorFields,
                                bankAccountNo: "",
                              },
                              errorStatus: {
                                ...prev.errorStatus,
                                bankAccountNo: false,
                              },
                            }));
                          }
                        }
                      }
                    }}
                    onBlur={(e) => {
                      handleAutoGenerateLedgerNameByAccountNo(e);
                    }}
                    size="small"
                    required={state?.ifscCode !== "" ? true : false}
                    sx={{
                      ".css-wgai2y-MuiFormLabel-asterisk": {
                        color: "danger.main",
                      },
                    }}
                  />
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.bankAccountNo}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: { sm: "flex-start" },
                  flexWrap: { xs: "wrap", md: "nowrap" },
                  flexDirection: { xs: "column", sm: "row" },
                  margin: "0px",
                }}
              >
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <TextField
                    error={state.errorStatus.branch === true ? true : false}
                    label="Swift Code"
                    name="swiftCode"
                    id="swiftCode"
                    fullWidth
                    value={state.swiftCode}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "") {
                        setState((prev) => ({
                          ...prev,
                          swiftCode: "",
                        }));
                      } else {
                        setState((prev) => ({
                          ...prev,
                          swiftCode: value,
                        }));
                      }
                    }}
                    size="small"
                    sx={{
                      ".css-wgai2y-MuiFormLabel-asterisk": {
                        color: "danger.main",
                      },
                    }}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                  />
                </Box>

                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <TextField
                    error={
                      state.errorStatus.accountType === true ? true : false
                    }
                    select
                    label="Bank Account Type"
                    name="accountType"
                    id="accountType"
                    required={state?.ifscCode !== "" ? true : false}
                    fullWidth
                    onChange={(e) => {
                      const name = e.target.name;
                      const value = e.target.value;
                      if (state?.ifscCode !== "") {
                        if (value != "addgstrate") {
                          if (value === "") {
                            setState((prev) => ({
                              ...prev,
                              ["accountType"]: value,
                              erroStatus: {
                                ...prev.errorStatus,
                                ["accountType"]: true,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                ["accountType"]:
                                  "Bank Account Type is required",
                              },
                            }));
                          } else {
                            setState((prev) => ({
                              ...prev,
                              ["accountType"]: value,
                              erroStatus: {
                                ...prev.errorStatus,
                                ["accountType"]: false,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                ["accountType"]: "",
                              },
                            }));
                          }
                        }
                      }
                    }}
                    vakue={state.accountType}
                    // required={true}
                    size="small"
                    sx={{
                      ".css-wgai2y-MuiFormLabel-asterisk": {
                        color: "danger.main",
                      },
                    }}
                  >
                    {AccountTypes.map((item, ind) => {
                      return (
                        <MenuItem key={item.value} value={`${item.value}`}>
                          <ListItemText
                            sx={{ margin: "0px" }}
                            primary={item.option}
                          />
                        </MenuItem>
                      );
                    })}
                  </TextField>
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.accountType}
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: { sm: "flex-start" },
                  flexWrap: { xs: "wrap", md: "nowrap" },
                  flexDirection: { xs: "column", sm: "row" },
                  marginBottom: "0px",
                }}
              >
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <TextField
                    error={state.errorStatus.name == true ? true : false}
                    name="name"
                    id="name"
                    label="Ledger Account"
                    fullWidth
                    value={state.name}
                    inputProps={{ maxLength: 30 }}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setState((prev) => ({
                          ...prev,
                          name: e.target.value,
                          errorFields: {
                            ...prev.errorFields,
                            name: "Ledger Account Name is required",
                          },
                          errorStatus: {
                            ...prev.errorStatus,
                            name: true,
                          },
                        }));
                      } else {
                        // let isvalid = true;
                        // ledger.map((item) => {
                        //   if (
                        //     item.AccountName.toLowerCase() ==
                        //     e.target.value.toLowerCase()
                        //   ) {
                        //     isvalid = false;
                        //   }
                        // });
                        // if (isvalid == false) {
                        //   setState((prev) => ({
                        //     ...prev,
                        //     name: e.target.value,
                        //     errorFields: {
                        //       name: "Ledger Account Name already exists",
                        //     },
                        //     errorStatus: {
                        //       name: true,
                        //     },
                        //   }));
                        // }
                        //  else {
                        setState((prev) => ({
                          ...prev,
                          name: e.target.value,
                          errorFields: {
                            name: "",
                          },
                          errorStatus: {
                            name: false,
                          },
                        }));
                        // }
                      }
                    }}
                    onFocus={(e) => {
                      if (e.target.value?.length === 0) {
                        const value =
                          state.bankName +
                          "" +
                          state.branch.slice(0, 4) +
                          "" +
                          state.bankAccountNo.toString().slice(-4);
                        setState((prev) => ({
                          ...prev,
                          name: value,
                          errorFields: {
                            ...prev.errorFields,
                            name: "",
                          },
                          errorStatus: { ...prev.errorStatus, name: false },
                        }));
                      }
                    }}
                    required={true}
                    size="small"
                    sx={{
                      ".css-wgai2y-MuiFormLabel-asterisk": {
                        color: "danger.main",
                      },
                    }}
                  />
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.name}
                  </Typography>
                </Box>
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <Autocomplete
                    disablePortal
                    id="groupName"
                    disableClearable
                    required={Boolean(state?.ifscCode !== "")}
                    options={group}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    value={state?.groupName}
                    onChange={(e, newValue) => {
                      setState((prev) => ({
                        ...prev,
                        groupName: newValue,
                        errorStatus: {
                          ...prev.errorStatus,
                          groupName: !newValue?.value,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          groupName: newValue?.value
                            ? ""
                            : "Group field is required",
                        },
                      }));
                    }}
                    sx={{
                      ".MuiFormLabel-asterisk": { color: "red" }, 
                    }}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={Boolean(state?.errorFields.groupName)}
                        label={
                          <>
                            Group <span style={{ color: "red" }}>*</span>
                          </>
                        }
                        sx={{
                          ".MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: state?.errorFields.groupName
                                ? "red"
                                : "input.border",
                            },
                            "&:hover fieldset": {
                              borderColor: state?.errorFields.groupName
                                ? "red"
                                : "input.border",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: state?.errorFields.groupName
                                ? "red"
                                : "primary.main",
                            },
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      fontSize: "11px",
                      color: "red",
                    }}
                  >
                    {state?.errorFields.groupName}
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  // padding : "15px",
                  // width:'100%',
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: { xs: "column", sm: "row" },
                }}
              >
                <Button
                  onClick={handleClose}
                  variant="outlined"
                  sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
                >
                  Cancel
                </Button>
                <LoadingButton
                  loading={loading}
                  disableRipple={true}
                  onClick={saveChanges}
                  variant="contained"
                  sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
                >
                  ADD
                </LoadingButton>
              </Box>
            </Box>
          </Paper>
        </Fade>
      </Modal>
    </Box>
  );
};

export default AddBankAccountModal;
